<template>
  <div class="flex flex-col">
    <div class="mb-1">
      {{ label }}
    </div>
    <div class="sm:flex">
      <div class="flex flex-1 flex-col">
        <tiptap
          ref="editor"
          :model-value="modelValue"
          @update:modelValue="(value) => $emit('update:modelValue', value)"
          ignore-placeholder-values
          :highlight-empty-placeholders="highlightEmptyPlaceholders"
        />
      </div>
      <div class="mt-2 sm:mt-0 sm:w-1/4 sm:pl-6" v-if="placeholderGroups">
        <div class="rounded-lg bg-gray-100 py-6 px-6">
          <h2 class="mb-1 text-lg font-semibold text-brand-500">{{ $t('placeholders.title') }}</h2>
          <p class="text-sm text-gray-600">
            {{ $t('placeholders.explanation') }}
          </p>
          <div
            class="mt-3 flex flex-col items-start"
            v-for="{ name, items } in placeholderGroups"
            :key="name"
          >
            <button
              type="button"
              class="font-semibold hover:text-brand-500"
              @click="toggleGroupExpansion(name)"
            >
              {{ name }}
              <span
                class="far ml-1"
                :class="groupIsExpanded(name) ? 'fa-angle-up' : 'fa-angle-down'"
              ></span>
            </button>
            <ul v-if="groupIsExpanded(name)">
              <li v-for="{ provider, item, name } in items" :key="provider + ':' + item">
                <button
                  type="button"
                  @click="addPlaceholder(provider, item, name)"
                  class="cursor-pointer leading-relaxed text-gray-800 hover:text-brand-500"
                >
                  {{ name }}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tiptap from './Tiptap'
export default {
  components: { Tiptap },
  props: {
    label: {
      type: String,
    },
    modelValue: {
      required: false,
    },
    placeholderGroups: {
      required: false,
    },
    highlightEmptyPlaceholders: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandedGroups: [],
      content: null,
    }
  },
  methods: {
    addPlaceholder(provider, item, label) {
      this.$refs['editor'].addPlaceholder(provider, item, label)
    },
    toggleGroupExpansion(name) {
      if (this.expandedGroups.includes(name)) {
        this.expandedGroups = this.expandedGroups.filter(function (value) {
          return value !== name
        })
      } else {
        this.expandedGroups.push(name)
      }
    },
    groupIsExpanded(name) {
      return this.expandedGroups.includes(name)
    },
    update(event) {
      this.$emit('update:modelValue', event.target.value)
    },
  },
  emits: ['update:modelValue'],
}
</script>
